export const FORM_GET = 'FORM_GET'
export const FORM_UPDATE = 'FORM_UPDATE'
export const FORM_CREATE = 'FORM_CREATE'



// WEBPACK FOOTER //
// ./src/store/actions/form.js